<script setup lang="ts">
import { ref } from 'vue';
import ProgressFrame from './layout/ProgressFrame.vue';
import VisualFailure from '../components/VisualFailure.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import ButtonOutlined from '@/shared/components/button/ButtonOutlined.vue';
import router from '@/router';
import { useCommissioningDeviceStore } from '../stores/commissioningDeviceStore';
import { message } from 'ant-design-vue';
import { optimisticallyGetCommissionState } from '../utils/output-connections';

const commissioningDeviceStore = useCommissioningDeviceStore();
const loadingRetry = ref(false);

const goToProjectSelect = () => {
  optimisticallyGetCommissionState();
  router.push({ name: 'ProjectSelect' });
};

const retryUpdate = async () => {
  loadingRetry.value = true;
  try {
    await commissioningDeviceStore.retrySoftwareUpdate();
    router.push({ name: 'SoftwareUpdate' });
  } catch (error) {
    message.error('Error retrying software update');
    loadingRetry.value = false;
  }
};
</script>

<template>
  <ProgressFrame pageClass="fullfocus-page">
    <div class="content">
      <VisualFailure>
        <template #title>The update wasn't successful</template>
      </VisualFailure>

      <ButtonPrimary
        block
        class="cta-button"
        @click="retryUpdate"
        :loading="loadingRetry"
        data-tn="software-update-retry-btn"
      >
        Let's try again
      </ButtonPrimary>
      <ButtonOutlined
        v-if="commissioningDeviceStore.softwareUpdate.forceUpdate === false"
        block
        class="cta-button"
        @click="goToProjectSelect"
      >
        Continue anyway
      </ButtonOutlined>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.cta-button {
  margin-top: 1.25rem;
}
</style>
